<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { ArrowDownTrayIcon, ChevronDownIcon } from "@heroicons/vue/24/solid";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  csvExportCallback: {
    type: Function,
    required: false,
  },
  xlsxExportCallback: {
    type: Function,
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
    required: false,
  },
});
</script>

<template>
  <Menu as="div" v-slot="{ open }" class="relative">
    <MenuButton
      class="flex items-center justify-center gap-2 rounded bg-indigo-600 px-3 py-1 text-sm text-white duration-150 hover:bg-indigo-950 disabled:cursor-not-allowed disabled:bg-opacity-60 disabled:hover:bg-indigo-600 disabled:hover:bg-opacity-60"
      :disabled="props.disabled"
    >
      <ArrowDownTrayIcon class="size-4" />
      {{ t("button.export") }}
      <ChevronDownIcon
        class="size-4 duration-150"
        :class="{ 'rotate-180': open }"
      />
    </MenuButton>

    <MenuItems
      class="absolute left-0 top-10 z-50 w-full rounded bg-white drop-shadow-md"
    >
      <MenuItem
        v-if="props.csvExportCallback"
        as="button"
        @click="props.csvExportCallback()"
        class="w-full cursor-pointer px-3 py-1 text-sm duration-150 hover:bg-gray-100 focus:bg-gray-100 focus:outline-0"
      >
        {{ t("button.csv") }}
      </MenuItem>

      <MenuItem
        v-if="props.xlsxExportCallback"
        as="button"
        @click="props.xlsxExportCallback()"
        class="w-full cursor-pointer px-3 py-1 text-sm duration-150 hover:bg-gray-100 focus:bg-gray-100 focus:outline-0"
      >
        {{ t("button.xlsx") }}
      </MenuItem>
    </MenuItems>
  </Menu>
</template>
